import ResponsibleStayApp from '@/vue/responsible-stay/App.vue'
import Vue from 'vue'

export default async function starter_responsibleStay() {
  let targetSection = document.querySelector('#responsible-stay-container')

  if (!targetSection) {
    targetSection = document.createElement('div')
    targetSection.id = 'responsible-stay-container'
    document.body.appendChild(targetSection)
  }

  new Vue({
    render: h => h(ResponsibleStayApp),
  }).$mount('#responsible-stay-container')

  console.log('Responsible Stay App Initialized')
}
